import media from 'style-utils/responsive-utils/media/media';
import styled from 'styled-components';

export const RegistrationCardBackgroundWrapper = styled.div`
  display: none;
  max-width: 50.1rem;
  width: 100%;
  height: 100%;
  ${media.desktop`display:block;`}
`;
